import styled from "styled-components";

export const PointContent = styled.div`
  gap: 16px;
  width: 100%;
  height: calc(100vh - 138px);
  display: flex;
  flex-direction: column;
`;

export const PointInfoBox = styled.div`
  gap: 20px;
  display: flex;
  padding: 36px 0 16px;
  box-shadow: ${(props) => props.theme.shadows.box};
  background: ${(props) => props.theme.colors.white100};
  border-radius: 10px;
  flex-direction: column;
`;

export const PointInfo = styled.div`
  gap: 12px;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  & > span {
    color: ${(props) => props.theme.colors.text2};
    font-size: 1.4rem;
  }
`;

export const Point = styled.div`
  color: ${(props) => props.theme.colors.black100};
  font-size: 2.4rem;
  font-weight: 700;

  span {
    font-size: 2rem;
    font-weight: 400;
  }
`;

export const PointFilterBox = styled.div`
  width: 100%;
  height: 70px;
  display: flex;
  padding: 0 16px;
  align-items: center;

  div + div {
    border-left: 1px solid ${(props) => props.theme.colors.black5};
  }
`;

export const PointFilterItem = styled.div`
  gap: 8px;
  width: 100%;
  color: ${(props) => props.theme.colors.text3};
  display: flex;
  font-size: 1.8rem;
  font-weight: 700;
  align-items: center;
  flex-direction: column;

  span {
    color: ${(props) => props.theme.colors.text2};
    font-size: 1.2rem;
    font-weight: 400;
  }
`;

export const PointHistoryBox = styled.div`
  flex: 1;
  width: 100%;
  height: auto;
  display: flex;
  overflow: hidden;
  background: ${(props) => props.theme.colors.mainBg};
`;
